module.exports = __webpack_public_path__ + "img/icon_Sliders.6b9cbbe3.png";